import Terms from "./Terms";

const TermsPage = () => <Terms />;

export default TermsPage;
